<template>
  <div class="responsive-table-holder">
    <table class="responsive-table report-table">
      <thead>
        <tr>
          <th
            v-for="col in columns"
            :key="col.name"
            @click="updateSort(col)"
          >
            {{ col.label }}
            <font-awesome-icon
              :icon="['fas', 'sort']"
              class="icon alt"
            />
            <span
              v-if="col.name == sortColumn"
              :class="ascending ? 'active-down' : 'active-up'"
            >
              <font-awesome-icon
                :icon="['fas', 'sort-down']"
                class="icon alt"
              />
              <font-awesome-icon
                :icon="['fas', 'sort-up']"
                class="icon alt"
              />
            </span>
          </th>
          <th />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="row in rows"
          :key="row.id"
        > 
          <td 
            v-for="col in columns"
            :key="col.name"
          >
            <span 
              v-if="(row[col.name] instanceof Date)"
            >
              {{ row[col.name] | dateOnly }}
            </span>
            <span 
              v-else-if="(row.details[col.name] instanceof Date)"
            >
              {{ row.details[col.name] | dateOnly }}
            </span>
            <span 
              v-else-if="col.name == 'files'"
            >
              <div 
                v-for="(file, file_index) in row['files']" 
                :key="file_index" 
                class="viewuploaded"
              >
                <a
                  v-b-popover.hover.bottom="{ html: true, content: file.filename}"
                  :href="file.url"
                  target="_blank"
                  style="margin: 2px;"
                >
                  <i
                    class="fa fa-download"
                    aria-hidden="true"
                  />
                </a>
              </div>
            </span>
            <span 
              v-else-if="row[col.name]"
            >
              {{ row[col.name] }}
            </span>
            <span 
              v-else
            >
              {{ row.details[col.name] }}
            </span>

            <!--This label recreates the table header in the modal display-->
            <label
              class="d-block d-md-none"
            >
              {{ col.label }}
            </label>
          </td>
          <td class="action-row">
            <button 
              v-b-popover.hover="{ title: 'Edit', content: 'Edit this vendor', variant: 'info' }"
              type="button"
              class="btn btn-primary"
              @click="editVendor(row, $event, 'edit')"
            >
              <i class="fa fa-edit" />
            </button>
            <button 
              v-if="row.benchmarked == 'not'" 
              v-b-popover.hover="{ title: 'Request Benchmarking for this Vendor', content: `Does ${row.vendor_name} meet all of your criteria? For the best price? Have Meet Virginia benchmark them against their competitors and find out.`, variant: 'info' }"
              type="button"
              class="btn btn-primary"
              @click="openBenchmarkModal(row)"
            >
              Get Benchmarked
            </button>
            <button 
              v-else-if="row.benchmarked == 'benching'" 
              v-b-popover.hover="{title: 'Benchmarking In Progess', content: 'Meet Virginia is building a side by side comparison for this vendor and its competitors.'}"
              type="button"
              class="btn"
              @click="openBenchmarkModal(row)"
            >
              Benchmark In Progress
            </button>
            <button 
              v-else-if="row.benchmarked == 'benched'"
              v-b-popover.hover="{title: 'Benchmarking Complete', content: 'You can now view the comparison of this vendor and its competitors built by Meet Virginia.'}"
              type="button"
              class="btn"
            >
              Benchmark Complete
            </button>
            <button 
              v-else-if="row.benchmarked == 'cannot'"
              v-b-popover.hover="{title: 'Cannot Benchmark', content: 'Meet Virginia was unable to find sufficient information on this vendor for a comparison analysis.'}"
              type="button"
              class="btn"
            >
              Cannot Benchmark
            </button>
          </td>
        <!-- </div> -->
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import VendorModel from '../../models/VendorModel';

export default {
  name: 'VendorTable',
  props: {
    items: {
      type: Array,
    },
    editVendor: {
      type: Function,
    },
    vendorFields: {
      type: Array,
    },
    openBenchmarkModal: {
      type: Function,
    }
  },
  data: () => ({
    ascending: true,
    sortColumn: "vendor_name",
  }),
  computed: {
    rows() {
      
      if (!this.items || !this.items.length) {
        return [];
      }
      const sortedList = [...this.items];
      return sortedList.sort((a, b) => {
        if ((a.details[this.sortColumn] || a[this.sortColumn]) && (!b.details[this.sortColumn] && !b[this.sortColumn])) return -1;
        if ((!a.details[this.sortColumn] && !a[this.sortColumn]) && (b.details[this.sortColumn] || b[this.sortColumn])) return 1;

        if ((a[this.sortColumn] ? a[this.sortColumn] : a.details[this.sortColumn]) > (b[this.sortColumn] ? b[this.sortColumn] : b.details[this.sortColumn])) {
          return this.ascending ? 1 : -1;
        } if ((a[this.sortColumn] ? a[this.sortColumn] : a.details[this.sortColumn]) < (b[this.sortColumn] ? b[this.sortColumn] : b.details[this.sortColumn])) {
          return this.ascending ? -1 : 1;
        }
        return 0;
      });
    },
    columns() {
      let model = new VendorModel();
     
      const cols = [...model.getColumns(), ...this.vendorFields];
      cols.sort((a,b) => a.default_order - b.default_order);
      return cols;
    },
  },
  methods: {
    updateSort(col) {
      if (this.sortColumn === col.name) {
        this.ascending = !this.ascending;
      } else {
        this.ascending = true;
        this.sortColumn = col.name;
      }
    },
    
  },
};
</script>

<style lang="scss" scoped>
.action-row {
  white-space: nowrap;
}

.responsive-table-holder {
  margin-top: 15px;
  overflow-x: auto;
}

button.btn.btn-primary.editvendor {
  margin-right: 6px;
}

.viewuploaded {
  display: inline;
  margin: 2px;
}

.report-table th:first-child,
.report-table td:first-child {
  position: sticky;
  left: 0;
  z-index: 2;
}

.report-table th {
  background: #fafafa;
}

.report-table td {
  background: white;
}

.action-row button:not(:last-of-type) {
  margin-right: 0.5em;
}

.responsive-table {
  border: none;
  background: white;

  &.report-table {
    tbody {
      tr {
        td {
          font-size: 15px;

          &:first-of-type {
            @media (min-width: $xl-min) {
              white-space: nowrap;
            }
          }
        }
      }

      .status {
        white-space: nowrap;
        min-width: 140px;

        i,
        svg {
          margin-right: 6px;
          opacity: 0.5;

          &.fa-times-circle {
            color: $red;
            opacity: 1;
          }

          &.fa-check-circle {
            color: $green;
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
